// document.querySelectorAll('.product-quantity').forEach(function(wrapper){

//   var minus = wrapper.querySelector(".quantity-minus");
//   var plus = wrapper.querySelector(".quantity-plus");
//   var input = wrapper.querySelector(".quantity-input input");

//   var minimum = 1;

//   minus.addEventListener("click", function(){
//     var current = parseInt(input.value) || minimum;

//     if(current > minimum){
//       input.value = current - 1;
//     }
//   });

//   plus.addEventListener("click", function(){
//     var current = parseInt(input.value) || minimum;
//     input.value = current + 1;
//   });

// });

document.querySelectorAll('.product-quantity').forEach(function(wrapper){

  var minus = wrapper.querySelector(".quantity-minus");
  var plus = wrapper.querySelector(".quantity-plus");
  var input = wrapper.querySelector(".quantity-input input");

  var minimum = 1;

  function toggleMinusButton() {
    var current = parseInt(input.value) || minimum;
    minus.disabled = current <= minimum;
  }

  toggleMinusButton();

  minus.addEventListener("click", function(){
    var current = parseInt(input.value) || minimum;

    if(current > minimum){
      input.value = current - 1;
      toggleMinusButton();
    }
  });

  plus.addEventListener("click", function(){
    var current = parseInt(input.value) || minimum;
    input.value = current + 1;
    toggleMinusButton();
  });

  input.addEventListener("input", function(){
    toggleMinusButton();
  });

});